import { CallerDTO } from './callback-on-callnote.model';

export enum SyncToAddressBookEnum {
	NO = 'NO',
	CREATE = 'CREATE',
	UPDATE = 'UPDATE',
}

export enum TelephoneTypeEnum {
	PHONE = 'phone',
	MOBILE = 'mobile',
	FAX = 'fax',
}

export interface CallerEditDialogParams {
	caller: CallerDTO;
	uid: string;
	syncedWithAddressBook: boolean;
}

export interface CallerCorrectionRequestDTO {
	salutation: string | null;
	firstName: string | null;
	lastName: string | null;
	company: string | null;
	formfields: CallerCorrectionFormfield[];
	syncToAddressBook: SyncToAddressBookEnum;
}

export interface CallerCorrectionFormfield {
	type: string;
	name: string;
}
